module.exports = __webpack_public_path__ + "img/digital_signage-menu-w.svg";